import React, { FC, useEffect, useState } from "react";
import classes from "./MediaCast.module.css";
import { motion } from "framer-motion";
import { filterJobs } from "../../Utils/helpers";
import { useNavigate } from "react-router-dom";

type MediaCastProps = {
  mediaDetails: any;
  windowWidth: number;
};

const MediaCast: FC<MediaCastProps> = ({ mediaDetails, windowWidth }) => {
  const [leftConstraint, setLeftConstraint] = useState<number>(0);

  useEffect(() => {
    const updateConstraints = () => {
      if (window.innerWidth <= 800) {
        setLeftConstraint(
          10 +
            mediaDetails?.result?.credits?.cast?.length * 150 +
            mediaDetails?.result?.credits?.cast?.length * 10 +
            mediaDetails?.result?.credits?.cast?.length * 1 -
            windowWidth
        );
      } else {
        setLeftConstraint(
          window.innerWidth * 0.05 +
            mediaDetails?.result?.credits?.cast?.length * 150 +
            mediaDetails?.result?.credits?.cast?.length * 10 +
            mediaDetails?.result?.credits?.cast?.length * 1 -
            windowWidth
        );
      }
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);

    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, [windowWidth, mediaDetails]);

  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const navigate = useNavigate();

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp = (
    event: React.MouseEvent<HTMLButtonElement>,
    personId: number,
    personName: string
  ) => {
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      navigate(`/person/${personId}/${personName}`);
    }
  };

  const handleMouseMove = () => {
    setIsDragging(true);
  };

  return (
    <div className={classes.carousel_container}>
      <motion.div
        className={classes.section_image_cards}
        style={{
          gridTemplateColumns: `repeat(${mediaDetails?.result?.credits?.cast?.length}, 150px)`,
        }}
        drag="x"
        dragConstraints={{
          top: 0,
          left: -leftConstraint,
          right: 0,
          bottom: 0,
        }}
        transition={{
          type: "spring",
          damping: 100,
          stiffness: 100,
        }}
      >
        {mediaDetails?.result?.credits?.cast?.map(
          (dataItem: any, idx: number) => (
            <button
              className={classes.cast_image_card}
              onMouseDown={(event) => handleMouseDown(event)}
              onMouseUp={(event) =>
                handleMouseUp(
                  event,
                  dataItem?.id,
                  dataItem?.name ?? dataItem?.original_name
                )
              }
              onMouseMove={handleMouseMove}
            >
              <div className={classes.cast_image}>
                {dataItem?.profile_path ? (
                  <img
                    src={`${process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
                      "<replace_media_id>",
                      dataItem?.profile_path
                    )}`}
                    alt="movie photos"
                    className={classes.cast_img}
                    onError={(e: any) =>
                      (e.target.src =
                        "/assets/images/avatar-image-not-found.png")
                    }
                  />
                ) : (
                  <img
                    src="/assets/images/avatar-image-not-found.png"
                    alt="movie photos"
                    className={classes.cast_img}
                    onError={(e: any) =>
                      (e.target.src =
                        "/assets/images/avatar-image-not-found.png")
                    }
                  />
                )}
              </div>

              <div className={classes.cast_card_content}>
                <p className={classes.original_name}>
                  {dataItem?.name ?? dataItem?.original_name}
                </p>
                <p className={classes.role_name}>{dataItem?.character}</p>
              </div>
            </button>
          )
        )}
      </motion.div>

      <div className={classes.movie_crew_container}>
        <div className={classes.crew_director}>
          <p className={classes.director}>Director </p>
          <div>
            {filterJobs(mediaDetails?.result?.credits?.crew, "Director")?.map(
              (data: any, idx: number) => {
                return (
                  <>
                    <p className={classes.director_name}>
                      <i className={`pi pi-circle-fill ${classes.bullet}`} />
                      {data?.name}
                    </p>
                  </>
                );
              }
            )}
          </div>
        </div>
        <div className={classes.crew_writor}>
          <p className={classes.writor}>Writer </p>
          <div>
            {filterJobs(mediaDetails?.result?.credits?.crew, "Writer")?.length >
            0
              ? filterJobs(mediaDetails?.result?.credits?.crew, "Writer")?.map(
                  (data: any, idx: number) => {
                    return (
                      <>
                        <p className={classes.writer_name}>
                          <i
                            className={`pi pi-circle-fill ${classes.bullet}`}
                          />

                          {data?.name}
                        </p>
                      </>
                    );
                  }
                )
              : filterJobs(mediaDetails?.result?.credits?.crew, "Story")?.map(
                  (data: any, idx: number) => {
                    return (
                      <>
                        <p className={classes.writer_name}>
                          <i
                            className={`pi pi-circle-fill ${classes.bullet}`}
                          />

                          {data?.name}
                        </p>
                      </>
                    );
                  }
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaCast;
